module.exports = __webpack_public_path__ + "static/media/93Connect_desktop.866e5dd7.svg";